import _slicedToArray from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import { BREAKPOINTS } from "../../../../constants/breakpoints";
import { ensureTrailingSlash } from "../../../../util/seo";
import { getLocalizedHref } from "../../../../util/translator";
import { SOCIAL_LINKS } from "../../../../constants/navigation";
import React, { memo, useCallback, useContext, useMemo } from 'react';
import { useMedia } from 'react-use';
import SocialIcons from "../social-icons";
import CookiePolicySettingsLink from "../cookie-policy-settings-link";
import LanguageSwitcher from "../../footer-language-switcher";
import { VideoAskLogo } from "../../../common";
import { useMainContext } from "../../../main-context";
import FooterContext from "../../footer-context";
import MenuLink from "./menu-link";
import { Accordion, useAccordions } from "./accordion";
import { Column, CompanyInfoColumn, Heading, LinksContainer, LinkColumns } from "./styled-components";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var LinksColumns = function LinksColumns() {
  var _useContext = useContext(FooterContext),
    palette = _useContext.palette,
    links = _useContext.links,
    onLinkClick = _useContext.onLinkClick,
    onLinksAccordionOpened = _useContext.onLinksAccordionOpened;
  var _useMainContext = useMainContext(),
    t = _useMainContext.t;
  var accordionGroup = useAccordions();
  var handleLinkClick = useCallback(function (link) {
    return function (event) {
      onLinkClick(_objectSpread(_objectSpread({}, link), {}, {
        event: event
      }));
    };
  }, [onLinkClick]);
  var renderLink = useCallback(function (rawLink) {
    var _rawLink = _slicedToArray(rawLink, 3),
      labelKey = _rawLink[0],
      hrefKey = _rawLink[1],
      key = _rawLink[2];
    if (labelKey === SOCIAL_LINKS) {
      return /*#__PURE__*/_jsx(SocialIcons, {
        onClick: onLinkClick
      }, key);
    }
    var label = t(labelKey);
    var href = ensureTrailingSlash(getLocalizedHref(hrefKey, t));
    var link = {
      label: label,
      href: href,
      key: key
    };
    var commonProps = {
      'onClick': handleLinkClick(link),
      key: key,
      'data-gtm-event': 'nav_element--footer',
      href: href,
      palette: palette
    };
    if (labelKey === 'public-footer.nav.customer-faves.videoask.title') {
      return /*#__PURE__*/_jsx(LinkColumns, _objectSpread(_objectSpread({}, commonProps), {}, {
        children: /*#__PURE__*/_jsx(VideoAskLogo, {
          width: 94
        })
      }));
    }
    return /*#__PURE__*/_jsx(MenuLink, _objectSpread(_objectSpread({}, commonProps), {}, {
      children: label
    }));
  }, [handleLinkClick, palette, t, onLinkClick]);
  var linksColumns = useMemo(function () {
    return Object.keys(links).map(function (heading) {
      return /*#__PURE__*/_jsxs(Column, {
        children: [/*#__PURE__*/_jsx(Heading, {
          palette: palette,
          children: t(heading)
        }), links[heading].map(function (link) {
          if (link.title) {
            return /*#__PURE__*/_jsx(Accordion, {
              accordionGroup: accordionGroup,
              link: link,
              palette: palette,
              renderLink: renderLink,
              t: t,
              onOpened: onLinksAccordionOpened
            }, link.title);
          }
          return renderLink(link);
        })]
      }, heading);
    });
  }, [links, palette, t, renderLink, accordionGroup, onLinksAccordionOpened]);
  var isMobile = useMedia("(max-width: ".concat(BREAKPOINTS.md - 1, "px)"), null);
  return /*#__PURE__*/_jsxs(LinksContainer, {
    children: [linksColumns, /*#__PURE__*/_jsx(CompanyInfoColumn, {
      children: isMobile !== null && isMobile && /*#__PURE__*/_jsxs(React.Fragment, {
        children: [/*#__PURE__*/_jsx(CookiePolicySettingsLink, {}), /*#__PURE__*/_jsx(LanguageSwitcher, {})]
      })
    })]
  });
};
LinksColumns.displayName = 'LinksColumns';
export default /*#__PURE__*/memo(LinksColumns);